export const isImage = {
    install: (app, options) => {
        app.config.globalProperties.isImage = function (filename: string): boolean {
            const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png'];
            
            return allowedExtensions.includes(filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2));
        };
    },
};